import React from 'react';

import Text from '../../atoms/Text';
import { Heading, Surface, SurfaceProps } from '../../atoms';

export interface Props
  extends Omit<SurfaceProps, 'backgroundColor' | 'padding'> {
  title: string;
  description?: string;
  sidebarContent?: React.ReactNode;
  contentStyle?: React.CSSProperties;
}

const FormSection: React.FunctionComponent<Props> = ({
  title,
  description,
  sidebarContent = null,
  contentStyle,
  children,
  ...surfaceProps
}) => {
  return (
    <Surface backgroundColor="grayLight1" padding="sm" {...surfaceProps}>
      <div className="row">
        <div className="col-12 col-md-4 col-xl-3">
          <Heading as="h3" size="sm2" weight="bold">
            {title}
          </Heading>
          {description && (
            <Text className="mt-2 mb-3" size="sm2">
              {description}
            </Text>
          )}

          {sidebarContent}
        </div>

        <div className="col-12 col-md-8 col-xl-9">
          <Surface backgroundColor="white" padding="sm" style={contentStyle}>
            {children}
          </Surface>
        </div>
      </div>
    </Surface>
  );
};
export default FormSection;
